module.exports = __webpack_public_path__ + "static/img/scoreShow.dc65e9a3.jpg";